export const isTouchDevice = () => {
    // modern way
    const hasCoarsePointer = window.matchMedia("(pointer: coarse)").matches;
    const canHover = window.matchMedia("(hover: hover)").matches;

    // traditional way as fallback
    const hasTouchEvents = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    
    return (hasCoarsePointer && !canHover) || hasTouchEvents;
}

export const detectDeviceType = () => {
  const ua = navigator.userAgent;

  // Signal 1: UA string (with the iOS 13+ iPad fix)
  // Modern iPads report as "MacIntel" but have multiple touch points
  const isIpadOS =
    /Macintosh/i.test(ua) && navigator.maxTouchPoints > 1;

  const uaTablet =
    isIpadOS ||
    /(tablet|ipad|playbook|silk)|(android(?!.*mobile))/i.test(ua);

  const uaMobile =
    !uaTablet &&
    /Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle/i.test(ua);

  // Signal 2: Screen dimensions
  // Use screen.width (physical screen), not window.innerWidth (viewport)
  // because viewport can be resized by the user
  const screenWidth = window.screen.width;
  const screenMobile = screenWidth < 768;
  const screenTablet = screenWidth >= 768 && screenWidth <= 1024;

  // Signal 3: Pointer/touch capability
  // "coarse" = finger (touchscreen), "fine" = mouse
  const hasCoarsePointer = window.matchMedia("(pointer: coarse)").matches;
  const hasTouchPoints = navigator.maxTouchPoints > 0;
  const likelyTouch = hasCoarsePointer || hasTouchPoints;

  // Now combine the signals with a scoring approach
  // Tablet check: UA says tablet, OR (touch device with tablet-sized screen)
  if (uaTablet || (likelyTouch && screenTablet)) {
    return "Tablet";
  }

  // Mobile check: UA says mobile, OR (touch device with small screen)
  if (uaMobile || (likelyTouch && screenMobile)) {
    return "Mobile";
  }

  // Default: desktop
  return "Desktop";
}